exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item-inside[data-v-74e364c4]{width:80%;max-width:500px}", ""]);

// exports
